import { render } from "./RightNavDrawer.vue?vue&type=template&id=28ca0572&scoped=true"
import script from "./RightNavDrawer.vue?vue&type=script&lang=js"
export * from "./RightNavDrawer.vue?vue&type=script&lang=js"

import "./RightNavDrawer.vue?vue&type=style&index=0&id=28ca0572&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ca0572"]])

export default __exports__